import { NgModule } from '@angular/core';

import { SafeHtmlPipe } from './directives/safe-html.pipe';

@NgModule({
  declarations: [SafeHtmlPipe],
  exports: [SafeHtmlPipe],
})
export class UtilModule {}
